module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAABB0lEQVR42mNgGAWjYBSMglEwCggBhcHmmAeUGMAExE5A3AXEBxUVFd8UFxf/h2Gg2BUgXg7EGUAsSYxjoPpIBtxAXC4mJvYS2QGEMFDPBiA2x+cYchwUrKen954Uh2Bx2FIgFsHmGFIcxArE0/FZxMTE9BCo5jgQHwbiS/jUgqIXqCYU3THEOogdiLfg8O1eII5B8jEyYAZiUyDuJjEE8QJGIF6FRdMlILYmIap5gbiDGg4qw6JhDhCzkZkzYyhxkAYWxRMoLWcocdBmNIVboFFIM8fgc5AeFoXitHYMPge1oSmqpodj8DkIFDWWQNwLxDeBWIgejiG36hgFo2AUjIJRMAoGKwAAzVyXWivq7TEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/pdf-viewer/ic_redo.png
// module id = 1280
// module chunks = 438